import React, { useEffect, useState } from "react";
import styled from "styled-components";
import dayjs from 'dayjs';
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Box, Modal } from "@mui/material";
import IconCalendar from "../../../assets/images/icon-clock-2.svg"
import thDate from "dayjs/locale/th";
import newAdapter from "./newAdapter";

const Container = styled.div`
    width: 100%;
    margin-bottom: 16px;

    .label {
        color: #2A2A2A;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
        margin-bottom: 16px;
    }

    .container-input {
        width: 100%;
        position: relative;

        &.disable {
            cursor: default;
        }

        .icon-box {
            position: absolute;
            top: 14px;
            right: 8px;
        }
    }

    .label-error {
        height: 16px;
        color: #F84242;
        font-size: 14px;
        font-weight: 300;
        margin-top: 4px;
    }
`;

const ButtonPanel = styled.div`
    height: 32px;
    padding: 0px 8px 8px 8px;
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 8px;

    .btn {
        width: 80px;
        height: 100%;
        border-radius: 8px;
        cursor: pointer;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
        transition: all 0.3s ease;

        &.primary {
            &.normal {
                background-color: #FBE250;
                color: #25368D;

                &:hover {
                    background-color: #FBE25099;
                }
            }

            &.disable {
                cursor: default;
                background-color: #FFF4B4;
                color: #838BB4;
            }
        }

        &.sencondary {
            &.normal {
                background-color: #FFFFFF;
                border: 1px solid #FBE250;
                color: #25368D;

                &:hover {
                    background-color: #FBE25099;
                }
            }
        }
    }
`;

const InputBox = styled.input`
    width: calc(100% - 32px);
    height: 50px;
    border-radius: 13px;
    border: 1px solid #FBE250;
    color: #25368D;
    font-size: 16px;
    font-weight: 400;
    padding: 0px 16px;

    &.backoffice {
        border: 1px solid #B5B5B5;
    }

    &.error {
        border: 1px solid #F84242;
    }

    &.disable {
        cursor: default;
        background-color: #B3B3B333;
    }
`;

const InputTimeBox = styled.div`
    width: 240px;
    /* height: 80px; */
    margin: 16px 8px 24px 8px;
    position: relative;

    .input {
        width: calc(100% - 16px);
        border-radius: 4px;
        border: 1px solid #FBE250;
        color: #25368D;
        font-size: 16px;
        font-weight: 400;
        padding: 8px;
        position: relative;
        
        &::-webkit-calendar-picker-indicator{
            display: block;
            top: 0;
            right: 0;
            height: 100%;
            width: 100%;
            position: absolute;
            background: transparent;
        }
    }

    .icon-time {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 8px;
    }
`;

function TimePickerComponent({
    label,
    value,
    placeholder,
    dateStringFormat,
    labelError,
    isError,
    disable,
    type,
    styleContainer,
    classContainer,
    onSelect,
}) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedTime, setSelectedTime] = useState(null);
    const [selectedTimeReal, setSelectedTimeReal] = useState(null);
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
        if (value) {
            setSelectedTime(value)
            setSelectedTimeReal(value)
            setInputValue(value);
        } else {
            setSelectedTime(null)
            setSelectedTimeReal(null)
            setInputValue("");
        }
    }, [value])

    function handleClick() {
        if (disable) return
        setSelectedTime(selectedTimeReal)
        setIsOpen(true)
    };
    function handleClose() {
        setIsOpen(false)
    };
    function handleConfirm() {
        if (!selectedTime) return
        setIsOpen(false)
        setSelectedTimeReal(selectedTime)
        setInputValue(selectedTime);
        onSelect && onSelect(selectedTime)
    };
    function handleChange(param) {
        const value = param.target.value;
        setSelectedTime(value)
    };

    return (
        <LocalizationProvider dateAdapter={newAdapter} adapterLocale={thDate}>
            <Container className={`${classContainer}`} style={{ ...styleContainer }}>
                {label && <div className="label">{label}</div>}
                <div className={`container-input ${disable ? "disable" : ""}`} onClick={handleClick}>
                    <InputBox
                        readOnly
                        className={`${type || ""} ${isError ? "error" : ""} ${disable ? "disable" : ""} `}
                        placeholder={placeholder || ""}
                        value={inputValue}
                    />
                    <img alt="img" className="icon-box" src={IconCalendar} />
                </div>
                <div className="label-error">{isError ? labelError : ""}</div>
                <Modal
                    className="content-center"
                    open={isOpen}
                    onClose={handleClose}
                >
                    <Box sx={{ backgroundColor: "#FFFFFF", borderRadius: "8px" }}>
                        <InputTimeBox >
                            <input className="input" type="time" onInput={handleChange} value={selectedTime || ""}/>
                            <img alt="img" className="icon-time" src={IconCalendar} />
                        </InputTimeBox>
                        <ButtonPanel>
                            <div className={`btn content-center sencondary normal`} onClick={handleClose}>ยกเลิก</div>
                            <div className={`btn content-center primary ${selectedTime ? "normal" : "disable"}`} onClick={handleConfirm}>ยืนยัน</div>
                        </ButtonPanel>
                    </Box>
                </Modal>
            </Container>
        </LocalizationProvider>
    )
}

export default TimePickerComponent;